<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch2-1">
<p class="chapterNumberC"><span class="t19"><span class="bold">C</span></span><span class="smallcaps"><span class="bold">HAPTER</span></span> <span class="t19"><span class="bold">2</span></span></p>
<p class="chapterTitleC"><span class="t26"><span class="bold">The Hope Street Gang and the Cholera Riots</span></span></p>
<p class="chapterYearC"><span class="t21"><span class="bold">1826–1832</span></span></p>
<p class="extractTextNoIndentTB"><em class="italic">It was a panic generated by a genuinely horrific discovery</em></p>
<p class="paraNoIndent"><span><img alt="images" class="dropcap" src="images/imgT.jpg" style="max-width:100%;"/></span>he names Burke and Hare have not only attained the status of infamy and notoriety in the history of crime: one of them gave the English language a terrible new word in the years after his death in 1829. A ‘Burker’ became a word signifying that lowest of all killers perhaps, a ‘Resurrection Man’, someone who was willing to kill in order to earn some money from the doctors who needed cadavers for their schools of surgery and anatomy. The two villains had started their horrendous trade in 1827 when an old pensioner who owed them £4 was killed and taken to Dr Knox’s anatomy school in Edinburgh. For his corpse, they received over £7 – much more than the sum he owed them.</p>
<p class="para">Clearly, this was a quick and easy way to earn some cash, so Burke and Hare developed their business into a murderous enterprise targeting tramps and prostitutes. But it led Burke to the gallows and Hare to a runaway life as a poor fugitive in London. Unfortunately for the poor and vulnerable of other cities in Britain, the trade in bodies had an appeal to other ‘Burkers’ and Liverpool had its own gang of these desperate individuals.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 13_ch21.vue?b58a7656